import { useEffect, useState } from "react"
import { useShared } from "@/lib/inertia"
import { cn } from "@/lib/cn"

export function Flash() {
  const { flash } = useShared()
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    setVisible(true)
    if (flash.notice || flash.alert) {
      const t = setTimeout(() => setVisible(false), 6000)
      return () => clearTimeout(t)
    }
  }, [flash.notice, flash.alert])

  if (!flash.notice && !flash.alert) return null
  if (!visible) return null

  const isAlert = !!flash.alert
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="flash"
      className={cn(
        "pointer-events-none fixed inset-x-0 top-4 z-50 flex justify-center px-4",
      )}
    >
      <div
        className={cn(
          "pointer-events-auto inline-flex max-w-md items-start gap-x-3 rounded-2xl px-4 py-3 text-sm shadow-lg shadow-ink-950/10 ring-1 backdrop-blur",
          isAlert
            ? "bg-red-50 text-red-900 ring-red-200"
            : "bg-ink-950/95 text-white ring-white/10",
        )}
      >
        <span
          aria-hidden="true"
          className={cn("mt-0.5 inline-block size-2 shrink-0 rounded-full", isAlert ? "bg-red-500" : "bg-brand-400")}
        />
        <span className="leading-snug">{flash.alert ?? flash.notice}</span>
        <button
          type="button"
          onClick={() => setVisible(false)}
          aria-label="Dismiss"
          className={cn(
            "relative ml-2 rounded-md p-0.5 before:absolute before:left-1/2 before:top-1/2 before:size-10 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']",
            isAlert ? "hover:bg-red-100" : "hover:bg-white/10",
          )}
        >
          <svg viewBox="0 0 16 16" className="size-3.5" aria-hidden="true">
            <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </div>
  )
}
